import React from 'react'
import FooterWidgetComponent from '../../widgets/FooterWidget/FooterWidgetComponent'
import TermsBannerComponent from './widget/TermsBanner/TermsBannerComponent'
import SectionAComponent from './widget/SectionA/SectionAComponent'

function Terms() {
  return (
    <div>
        <TermsBannerComponent/>
        <SectionAComponent/>
        <FooterWidgetComponent/>
    </div>
  )
}

export default Terms